export default {"src":"/_next/static/media/RKT.cb650f69.svg","height":18,"width":18};